import { staticContentUrl } from '../../config';

export default function (language, file) {
  return `${staticContentUrl}/${language}/${file}`;
}
